import { Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalpopService } from '../modalpop.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ScrutinyPopupComponent } from '../scrutiny-popup/scrutiny-popup.component';

@Component({
  selector: 'app-scrutiny',
  templateUrl: './scrutiny.component.html',
  styleUrls: ['./scrutiny.component.scss']
})
export class ScrutinyComponent implements OnInit {
  ScrutinyForm: FormGroup;
  submitpayload: any;
  submitButton = true;
  editButton = false;
  showSubmitButton = true;
  Table = false;
  Intake = false;
  APIService: any;
  ScrutinyTable: [];
  colrChang=false;
  CountTable: [];
  dialogRef: MatDialogRef<any>;
  dialogRef1: MatDialogRef<any>;
  sessionList: any[];
  SessionFilterList: any[];
  sessionId = 0;
  CoCode = 0;
  CgCode = 0;
  CourseList: any;
  filteredListCourse: any;
  collegeList: any;
  filteredCollegeList: any;
  CountTableForApp: any[];
  inteckCount: number;
  scrutiny: string;
  scrutinyStatusArray: any;
  userPermission: any;
  UserCollege: any;
  // jsonData: any;
  constructor(private dialog: MatDialog,
    public umsService: UmsService,
    private modalPopupService: ModalpopService,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private spinner: NgxSpinnerService
  ) { this.APIService = environment.serviceUrl; }


  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.Table = false
    this.Intake = false;
    this.sessionId = 0;
    this.CoCode = 0;
    this.CgCode = 0;
    let id = ''
    this.submitButton = true;
    this.editButton = false;
    this.ScrutinyForm = this.fb.group({
      college: new FormControl(''),
      course: new FormControl(''),
      SessionId: new FormControl(''),
    });
    this.fetchSession(id);
  }

  fetchSession(id) {
    this.spinner.show();
    const payload = {};
    this.filteredListCourse = [];
    this.filteredCollegeList  = [];
    payload['SnDefault'] = id;
    payload['SnNo'] = id; 
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.sessionList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   })
  }

  getCourse(id){
    this.Table = false;
    this.Intake = false;
    this.ScrutinyForm.controls['course'].setValue('');
    this.filteredListCourse = [];
    this.filteredCollegeList  = [];
    this.CourseList = [];
    this.spinner.show();
    this.sessionId = id
    const payload = {};
    payload['SessionId'] = id; 
    this.umsService.fetchIntakeFilter(payload).subscribe(res => {
      if(res.status){
        this.spinner.hide();
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
      else{
        this.spinner.hide();
        this.CourseList = [];
        this.filteredListCourse = [];
      }
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.CourseList = [];
      //this.spinner.hide();
      // let  data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Information';
      // data['icon'] = 'fas fa-box-open';
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
      // this.umsService.openSnackbar(ERROR.error.message);
   })
  }

  getClg(CoCode){
   this.ScrutinyForm.controls['college'].setValue('');
   this.spinner.show()
   this.Table = false;
   this.Intake = false;
   this.collegeList = [];
   this.filteredCollegeList = [];
   this.CoCode = CoCode;
   if(this.userPermission[0].CgUi == 'C'){
     this.UserCollege= this.userPermission[0].CgId;
     const payload = {};
     payload['CgCode'] = this.UserCollege
     this.umsService.getCollege(payload).subscribe((res) => {
       if(res.status){
         this.spinner.hide()
         this.collegeList = res.data;
         this.filteredCollegeList = this.collegeList.slice();
       }
       else{
         this.spinner.hide()
         this.collegeList = []
         this.filteredCollegeList = []
       }
     },(ERROR: HttpErrorResponse) => {
       this.spinner.hide()
       this.collegeList = []
       this.filteredCollegeList = []
     })
   }
   else{
     this.UserCollege = ''
     const payload = {};
     payload['SessionId'] = this.sessionId; 
   payload['CoCgCoCode'] = CoCode; 
   this.umsService.fetchIntakeFilter(payload).subscribe(res => {
     if(res.status){
       this.spinner.hide()
       this.collegeList = res.data;
       this.filteredCollegeList = this.collegeList.slice();
     }
     else{
       this.spinner.hide()
       this.collegeList = []
       this.filteredCollegeList = []
     }
    
   },(ERROR: HttpErrorResponse) => {
     this.spinner.hide()
     this.collegeList = []
     this.filteredCollegeList = []
   })
   }
   
   
  }

  ShowTable(item){
    this.CgCode = item.CoCgCgCode ? item.CoCgCgCode : item.CgCode;
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = item.CoCgCgCode ? item.CoCgCgCode : item.CgCode
    this.umsService.getScrutiny(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.Table = true;
        this.ScrutinyTable = res.data;
        if(res.data[0]['Intake']==true){
          this.getCount();
          this.Intake = true;
        }
        else{
          this.Intake = false;
        }
        this.ScrutinyHistoryTable()
      } else {
        if(res.message == 'No Data Found'){
          this.ScrutinyTable = [];
          this.Intake = false;
          this.Table = false;
        }
        
      }
     
    });
    
  }

  getCount() {
    const payload = {};
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = this.CgCode
    this.umsService.getScrutinyCount(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
       this.CountTable = res.data;
       this.inteckCount = res.data[0].PermittedIntake;
      } else {
        if(res.message == 'No Data Found'){
          this.CountTable = [];
        }
        
      }
     
    });
  }

  openModal(id) {
    let data = {};
    data['ScrutinyLevel'] = id.ScrutinyLevel;
    data['UserId'] = id.UserId; 
    data['ScrutinyId'] = id.ScrutinyId;
    this.dialogRef1 = this.dialog.open(ScrutinyPopupComponent, {
      disableClose: true,
      width: "600px",
      height: "280px",
      // height: 'auto', 
      data,
    });
    this.dialogRef1.afterClosed().subscribe((result) => {
      this.ngOnInit();
      // this.getData();

    });
    this.dialogRef.afterClosed().subscribe((result) => {
      this.ngOnInit();
      // this.getData();

    })
  }



  addnewrecord(e) {
    if (e === 'true') {

      this.editButton = false;
      this.submitButton = true;
      this.ScrutinyForm.reset();
    }
    else {

      this.editButton = true;
      this.submitButton = false;

    }
  }
  redirect(to): void {
    this.router.navigate([to]);
  }

  // details(data){
  //   this.router.navigate(['student-profile'],
  //   { queryParams: { 
  //     ScrutinyLevel: data.ScrutinyLevel,
  //     UserId: data.UserId,
  //     ScrutinyId: data.ScrutinyId,
  //     StudentId: data.StudentId,
  //     LoginFullName: data.LoginFullName,
  //     StuFirstName: data.StuFirstNameEng,
  //     StuMidName: data.StuMidNameEng,
  //     StuLastName: data.StuLastNameEng,
  //     CoCode: data.CoCode,
  //     CgCode: data.CgCode,
  //     SessionId: data.SessionId
  //   }}); 
  // }

  // details(data){
  //   this.router.navigate(['student-profile'],
  //   { state: { 
  //     ScrutinyLevel: data.ScrutinyLevel,
  //     UserId: data.UserId,
  //     ScrutinyId: data.ScrutinyId,
  //     StudentId: data.StudentId,
  //     LoginFullName: data.LoginFullName,
  //     StuFirstName: data.StuFirstNameEng,
  //     StuMidName: data.StuMidNameEng,
  //     StuLastName: data.StuLastNameEng,
  //     CoCode: data.CoCode,
  //     CgCode: data.CgCode,
  //     SessionId: data.SessionId
  //   }}); 
  // }

  details(data) {
    // Store data in localStorage
    localStorage.setItem('ScrutinyLevel', data.ScrutinyLevel);
    localStorage.setItem('UserId', data.UserId);
    localStorage.setItem('ScrutinyId', data.ScrutinyId);
    localStorage.setItem('StudentId', data.StudentId);
    localStorage.setItem('LoginFullName', data.LoginFullName);
    localStorage.setItem('StuFirstName', data.StuFirstNameEng);
    localStorage.setItem('StuMidName', data.StuMidNameEng);
    localStorage.setItem('StuLastName', data.StuLastNameEng);
    localStorage.setItem('CoCode', data.CoCode);
    localStorage.setItem('CgCode', data.CgCode);
    localStorage.setItem('SessionId', data.SessionId);
  
    // Navigate to student-profile
    this.router.navigate(['student-profile'], {
      state: { 
        ScrutinyLevel: data.ScrutinyLevel,
        UserId: data.UserId,
        ScrutinyId: data.ScrutinyId,
        StudentId: data.StudentId,
        LoginFullName: data.LoginFullName,
        StuFirstName: data.StuFirstNameEng,
        StuMidName: data.StuMidNameEng,
        StuLastName: data.StuLastNameEng,
        CoCode: data.CoCode,
        CgCode: data.CgCode,
        SessionId: data.SessionId
      }
    });
  }
  
  approvedStudent(){
   var appCount = this.CountTable;
   const payload = {};
   payload['UserId'] = sessionStorage.getItem('userId');
   payload['SessionId'] = this.sessionId;
   payload['CoCode'] = this.CoCode;
   payload['CgCode'] = this.CgCode
   this.umsService.getScrutinyCount(payload).subscribe((res) => {
     if (res.status) {
      this.CountTableForApp = res.data;
     } else {
       if(res.message == 'No Data Found'){
         this.CountTableForApp = [];
       }
     }
    
   });

   if(this.CountTableForApp[0].PermittedIntake < this.CountTableForApp[0].Approved){
      this.colrChang = true;
   }
  }

  ScrutinyHistoryTable(){
    this.scrutiny = ''
    const payload = {};
    payload['CoCode'] =  this.CoCode;
    payload['CgCode'] =  this.CgCode;
    payload['SessionId'] =  this.sessionId;
    this.umsService.ScrutinyHistoryTable(payload).subscribe((res) => {
      this.scrutinyStatusArray = res.data[0];
      
    })
  }

  getLoginFullName(studentId: number, status: string): string {
    if (status === 'Submitted' || status === 'ReSubmitted') {
        return '';
    } else {
        const matchingScrutiny = this.scrutinyStatusArray.find(scrutiny => scrutiny.StudentId == studentId && scrutiny.LoginName != null);
        return matchingScrutiny ? matchingScrutiny.LoginName : '';
    }
}
}
